// Auto-generated from Firefoo product mapping. Do not edit manually unless the source mapping changes.
export const gumroadProductOptions = [
  { label: "Bannerify (AU Business)", value: "FUo7kr7eDs6AlEF8mDtGXA==" },
  { label: "Bannerify (AU Freelancer)", value: "r0PpVS0vC9ZTHDKglgKCDQ==" },
  { label: "Bannerify (AU Team)", value: "78TNqrkJ_ya8sTeJE-kxYg==" },
  { label: "Bannerify (Business)", value: "nnGHFuOd73r35gXPrNIcbg==" },
  { label: "Bannerify (Freelancer)", value: "EHBOKmLP_Q-FHzG1f0Wu3g==" },
  { label: "Bannerify (Multi-Seat)", value: "S5wlkMBNCIQSxXXthNUEHw==" },
  { label: "Bannerify (Team)", value: "AlhAsB6MELNA0GNCJncs8Q==" },
  { label: "Commentful (Business)", value: "IV6hmfqrh1tbQfn2kZjU5w==" },
  { label: "Commentful (Freelancer)", value: "LU7wE9IqOQgA23R-HJCwcg==" },
  { label: "Commentful (Multi-Seat)", value: "YtBbUQl8aXK9NFFkbSxeZg==" },
  { label: "Commentful (Team)", value: "fCyyurHs3CUYtz_wW-GDBg==" },
  { label: "Convertify (Business)", value: "-6_D2pjfmOV82vgVH7mSTg==" },
  { label: "Convertify (Freelancer)", value: "CAF6R9JsY44fJehL8m9usA==" },
  { label: "Convertify (Multi-Seat)", value: "QrtbWg52IFuGrn5jwtx-MA==" },
  { label: "Convertify (Team)", value: "MkkT3bOEmPKwN_Vvly02-w==" },
  { label: "CopyDoc (Business)", value: "ySFY2r7p9Z7pk_YfeAmoqA==" },
  { label: "CopyDoc (Freelancer)", value: "qnEP2UWQACTNxVHuxNwIUw==" },
  { label: "CopyDoc (Multi-Seat)", value: "zgTVfEeUFRum29fgvnI_wQ==" },
  { label: "CopyDoc (Team)", value: "XMZ8sv_BfvW0WGHmAW_sHw==" },
  { label: "Crypto (AU Business)", value: "MurNgAYSEj1ZgNLhnF0ayQ==" },
  { label: "Crypto (AU Freelancer)", value: "Ra2QwasjuglEpb-WkvjCKA==" },
  { label: "Crypto (AU Team)", value: "Al93BdKBgXzmOQUVsClWSw==" },
  { label: "Crypto (Business)", value: "UyhqH8dCztqoBMK3YH-tzA==" },
  { label: "Crypto (Freelancer)", value: "FDAcycjzfNGmZNAM8wlvQQ==" },
  { label: "Crypto (Legacy Freelancer)", value: "44A5RTrwjkl2k0bpi3qhqw==" },
  { label: "Crypto (Multi-Seat)", value: "p1lXKxPvwi6IqreUZsglxQ==" },
  { label: "Crypto (Team)", value: "zNMyYt8WzgEt75Wc9W9EVg==" },
  { label: "Emailify (Business)", value: "N5CckidHuHPdxJPALwW6zg==" },
  { label: "Emailify (Freelancer)", value: "iRAX5zNvEZy-eiVU1t7MIg==" },
  { label: "Emailify (Multi-Seat)", value: "iAlfHJ3atH9W0TAEFhVX6Q==" },
  { label: "Emailify (Team)", value: "aUWVrYHiGVuxFIHqrz1YIA==" },
  { label: "Favvy (Business)", value: "yUzxWz6TEzeFNc9cGUUTGA==" },
  { label: "Favvy (Freelancer)", value: "86kKv7N4ZQSwFKtXbHYTww==" },
  { label: "Favvy (Multi-Seat)", value: "DxMCneBCPFbhel0Hs4G0OA==" },
  { label: "Favvy (Team)", value: "TC1H0K1-_4Yiv4izziasxw==" },
  { label: "HyperCrop (Business)", value: "Q3q6tGw8eh84jpYjYzV4jA==" },
  { label: "HyperCrop (Freelancer)", value: "3OOqmHR8W-BNZmGnaA5tWw==" },
  { label: "HyperCrop (Multi-Seat)", value: "XmnY9aAjX3cDUHgY3FIlUQ==" },
  { label: "HyperCrop (Team)", value: "fMTIfgiU2gtJN7nUbfv2EA==" },
  { label: "Pitchdeck (AU Business)", value: "h5_dVrS_8b3EtjnGZUIy8g==" },
  { label: "Pitchdeck (AU Freelancer)", value: "sPdQCFeEeXE-CZebgY5zsg==" },
  { label: "Pitchdeck (AU Team)", value: "-o9ToTeFd8upn49Pot85ew==" },
  { label: "Pitchdeck (Business)", value: "RuiCOH2J63cPXrMZDNI76Q==" },
  { label: "Pitchdeck (Freelancer)", value: "B3LsRzzi_nrApzzJaiEeHQ==" },
  { label: "Pitchdeck (Legacy Freelancer)", value: "3oGeLgg7H6jtXn1Tjy9UKw==" },
  { label: "Pitchdeck (Multi-Seat)", value: "ik7qGD-Tn9NnL1ZgjjH-6w==" },
  { label: "Pitchdeck (Team)", value: "6Yl80TLXgRow-pMIxeK5bA==" },
  { label: "Pixelay (AU Business)", value: "v_MoNQ8B0YSiFJHB9p2nAw==" },
  { label: "Pixelay (AU Freelancer)", value: "4qpVFXGmGA-oPLCIqg0tnQ==" },
  { label: "Pixelay (AU Team)", value: "Yiq8Lc2jmIgeygIlX-o7xA==" },
  { label: "Pixelay (Business)", value: "uf26HqASPHZpT4fzQKW4Tw==" },
  { label: "Pixelay (Freelancer)", value: "SyF56ckoIJx8EGtgCgZl0g==" },
  { label: "Pixelay (Legacy Freelancer)", value: "wqvvcsfOArje9Vp7XM-jsw==" },
  { label: "Pixelay (Multi-Seat)", value: "y3ki9bR27Jeam5ddL6iu2A==" },
  { label: "Pixelay (Team)", value: "KdOcLPiN06uF0WWRjj4QcQ==" },
  { label: "Pro Bundle (Business)", value: "rLzyVHaKnWISSGVkpqcsRg==" },
  { label: "Pro Bundle (Freelancer)", value: "jhkbIEUHDs6qNFXE0VPokw==" },
  { label: "Pro Bundle (Multi-Seat)", value: "O9582Lkkf7NqxRcIb1dAJA==" },
  { label: "Pro Bundle (Team)", value: "7y2nVLX2XqPtENOp_miqIQ==" },
  { label: "TinyImage (AU Business)", value: "sSgI5XzgpJHfYsOSlmSZEA==" },
  { label: "TinyImage (AU Freelancer)", value: "uEev7TsKllwd_EnLqx9NAw==" },
  { label: "TinyImage (AU Team)", value: "NvkHbHOv41SXyy6xFtHC4Q==" },
  { label: "TinyImage (Business)", value: "Mqw-SuwUbjsLyUl0cL7NwQ==" },
  { label: "TinyImage (Freelancer)", value: "87Lz5x2EGS_V2JlT5Wdj4A==" },
  { label: "TinyImage (Legacy Freelancer)", value: "2zpDAINrZvWfYWN1PgGUmQ==" },
  { label: "TinyImage (Multi-Seat)", value: "cnB5KlRGUhQTI-5rE20duQ==" },
  { label: "TinyImage (Team)", value: "UbbebKfcyn1tbGmoFfWRsg==" },
  { label: "Weblify (Multi-Seat)", value: "wye5lxKiEzKmcwXE66_jcA==" }
];

export const gumroadProductIdByPermalink = {
  AOPVZ: "78TNqrkJ_ya8sTeJE-kxYg==",
  ArrjN: "h5_dVrS_8b3EtjnGZUIy8g==",
  AwRPF: "MkkT3bOEmPKwN_Vvly02-w==",
  BdjqZ: "UbbebKfcyn1tbGmoFfWRsg==",
  CXjRe: "v_MoNQ8B0YSiFJHB9p2nAw==",
  CubOx: "jhkbIEUHDs6qNFXE0VPokw==",
  DFUob: "3oGeLgg7H6jtXn1Tjy9UKw==",
  DYhREl: "7y2nVLX2XqPtENOp_miqIQ==",
  FXIjH: "sPdQCFeEeXE-CZebgY5zsg==",
  FcPCy: "6Yl80TLXgRow-pMIxeK5bA==",
  FkADG: "3OOqmHR8W-BNZmGnaA5tWw==",
  GktBQ: "sSgI5XzgpJHfYsOSlmSZEA==",
  IBMUI: "FDAcycjzfNGmZNAM8wlvQQ==",
  JLnmd: "Al93BdKBgXzmOQUVsClWSw==",
  JYiEs: "NvkHbHOv41SXyy6xFtHC4Q==",
  JkmZx: "rLzyVHaKnWISSGVkpqcsRg==",
  KCpag: "Q3q6tGw8eh84jpYjYzV4jA==",
  NOqos: "UyhqH8dCztqoBMK3YH-tzA==",
  OZnNR: "44A5RTrwjkl2k0bpi3qhqw==",
  PNDLw: "CAF6R9JsY44fJehL8m9usA==",
  QHAZG: "fMTIfgiU2gtJN7nUbfv2EA==",
  SUQkWM: "B3LsRzzi_nrApzzJaiEeHQ==",
  TurPb: "EHBOKmLP_Q-FHzG1f0Wu3g==",
  VenFI: "RuiCOH2J63cPXrMZDNI76Q==",
  VpYza: "MurNgAYSEj1ZgNLhnF0ayQ==",
  WNknR: "Mqw-SuwUbjsLyUl0cL7NwQ==",
  XcmDn: "wqvvcsfOArje9Vp7XM-jsw==",
  arPVe: "uEev7TsKllwd_EnLqx9NAw==",
  arvdj: "O9582Lkkf7NqxRcIb1dAJA==",
  aubannerifybusiness: "FUo7kr7eDs6AlEF8mDtGXA==",
  aubannerifyfreelancer: "r0PpVS0vC9ZTHDKglgKCDQ==",
  aubannerifyteam: "78TNqrkJ_ya8sTeJE-kxYg==",
  aucryptobusiness: "MurNgAYSEj1ZgNLhnF0ayQ==",
  aucryptofreelancer: "Ra2QwasjuglEpb-WkvjCKA==",
  aucryptoteam: "Al93BdKBgXzmOQUVsClWSw==",
  aupitchdeckbusiness: "h5_dVrS_8b3EtjnGZUIy8g==",
  aupitchdeckfreelancer: "sPdQCFeEeXE-CZebgY5zsg==",
  aupitchdeckteam: "-o9ToTeFd8upn49Pot85ew==",
  aupixelaybusiness: "v_MoNQ8B0YSiFJHB9p2nAw==",
  aupixelayfreelancer: "4qpVFXGmGA-oPLCIqg0tnQ==",
  aupixelayteam: "Yiq8Lc2jmIgeygIlX-o7xA==",
  autinyimagebusiness: "sSgI5XzgpJHfYsOSlmSZEA==",
  autinyimagefreelancer: "uEev7TsKllwd_EnLqx9NAw==",
  autinyimageteam: "NvkHbHOv41SXyy6xFtHC4Q==",
  awMdS: "2zpDAINrZvWfYWN1PgGUmQ==",
  bannerify: "S5wlkMBNCIQSxXXthNUEHw==",
  bannerifybusiness: "nnGHFuOd73r35gXPrNIcbg==",
  bannerifyfreelancer: "EHBOKmLP_Q-FHzG1f0Wu3g==",
  bannerifyteam: "AlhAsB6MELNA0GNCJncs8Q==",
  bundle: "O9582Lkkf7NqxRcIb1dAJA==",
  bundlebusiness: "rLzyVHaKnWISSGVkpqcsRg==",
  bundlefreelancer: "jhkbIEUHDs6qNFXE0VPokw==",
  bundleteam: "7y2nVLX2XqPtENOp_miqIQ==",
  commentful: "YtBbUQl8aXK9NFFkbSxeZg==",
  commentfulbusiness: "IV6hmfqrh1tbQfn2kZjU5w==",
  commentfulfreelancer: "LU7wE9IqOQgA23R-HJCwcg==",
  commentfulteam: "fCyyurHs3CUYtz_wW-GDBg==",
  convertify: "QrtbWg52IFuGrn5jwtx-MA==",
  convertifybusiness: "-6_D2pjfmOV82vgVH7mSTg==",
  convertifyfreelancer: "CAF6R9JsY44fJehL8m9usA==",
  convertifyteam: "MkkT3bOEmPKwN_Vvly02-w==",
  copydoc: "zgTVfEeUFRum29fgvnI_wQ==",
  copydocbusiness: "ySFY2r7p9Z7pk_YfeAmoqA==",
  copydocfreelancer: "qnEP2UWQACTNxVHuxNwIUw==",
  copydocteam: "XMZ8sv_BfvW0WGHmAW_sHw==",
  crypto: "p1lXKxPvwi6IqreUZsglxQ==",
  cryptobusiness: "UyhqH8dCztqoBMK3YH-tzA==",
  cryptofreelance: "44A5RTrwjkl2k0bpi3qhqw==",
  cryptofreelancer: "FDAcycjzfNGmZNAM8wlvQQ==",
  cryptoteam: "zNMyYt8WzgEt75Wc9W9EVg==",
  drJbd: "-6_D2pjfmOV82vgVH7mSTg==",
  emailify: "iAlfHJ3atH9W0TAEFhVX6Q==",
  emailifybusiness: "N5CckidHuHPdxJPALwW6zg==",
  emailifyfreelancer: "iRAX5zNvEZy-eiVU1t7MIg==",
  emailifyteam: "aUWVrYHiGVuxFIHqrz1YIA==",
  evCtv: "XMZ8sv_BfvW0WGHmAW_sHw==",
  favvy: "DxMCneBCPFbhel0Hs4G0OA==",
  favvybusiness: "yUzxWz6TEzeFNc9cGUUTGA==",
  favvyfreelancer: "86kKv7N4ZQSwFKtXbHYTww==",
  favvyteam: "TC1H0K1-_4Yiv4izziasxw==",
  ffigd: "ik7qGD-Tn9NnL1ZgjjH-6w==",
  fqhgoy: "S5wlkMBNCIQSxXXthNUEHw==",
  fzmjf: "QrtbWg52IFuGrn5jwtx-MA==",
  hRXRQS: "86kKv7N4ZQSwFKtXbHYTww==",
  hkkml: "DxMCneBCPFbhel0Hs4G0OA==",
  hypercrop: "XmnY9aAjX3cDUHgY3FIlUQ==",
  hypercropbusiness: "Q3q6tGw8eh84jpYjYzV4jA==",
  hypercropfreelancer: "3OOqmHR8W-BNZmGnaA5tWw==",
  hypercropteam: "fMTIfgiU2gtJN7nUbfv2EA==",
  iGAMx: "AlhAsB6MELNA0GNCJncs8Q==",
  iGPbA: "iRAX5zNvEZy-eiVU1t7MIg==",
  iccid: "p1lXKxPvwi6IqreUZsglxQ==",
  irOBt: "-o9ToTeFd8upn49Pot85ew==",
  lrfuis: "zgTVfEeUFRum29fgvnI_wQ==",
  lzhhcl: "YtBbUQl8aXK9NFFkbSxeZg==",
  mcsLQ: "qnEP2UWQACTNxVHuxNwIUw==",
  mndpGd: "N5CckidHuHPdxJPALwW6zg==",
  nbMdt: "ySFY2r7p9Z7pk_YfeAmoqA==",
  niefv: "Yiq8Lc2jmIgeygIlX-o7xA==",
  npbov: "fCyyurHs3CUYtz_wW-GDBg==",
  oahyv: "XmnY9aAjX3cDUHgY3FIlUQ==",
  ogutv: "zNMyYt8WzgEt75Wc9W9EVg==",
  ohhKQz: "Ra2QwasjuglEpb-WkvjCKA==",
  pitchdeck: "ik7qGD-Tn9NnL1ZgjjH-6w==",
  pitchdeckbusiness: "RuiCOH2J63cPXrMZDNI76Q==",
  pitchdeckfreelance: "3oGeLgg7H6jtXn1Tjy9UKw==",
  pitchdeckfreelancer: "B3LsRzzi_nrApzzJaiEeHQ==",
  pitchdeckteam: "6Yl80TLXgRow-pMIxeK5bA==",
  pixelay: "y3ki9bR27Jeam5ddL6iu2A==",
  pixelaybusiness: "uf26HqASPHZpT4fzQKW4Tw==",
  pixelayfreelance: "wqvvcsfOArje9Vp7XM-jsw==",
  pixelayfreelancer: "SyF56ckoIJx8EGtgCgZl0g==",
  pixelayteam: "KdOcLPiN06uF0WWRjj4QcQ==",
  piyjt: "wye5lxKiEzKmcwXE66_jcA==",
  psYqj: "KdOcLPiN06uF0WWRjj4QcQ==",
  qHFQa: "4qpVFXGmGA-oPLCIqg0tnQ==",
  qSszQ: "aUWVrYHiGVuxFIHqrz1YIA==",
  rKeoj: "TC1H0K1-_4Yiv4izziasxw==",
  saldw: "y3ki9bR27Jeam5ddL6iu2A==",
  svzjog: "cnB5KlRGUhQTI-5rE20duQ==",
  tdwiM: "yUzxWz6TEzeFNc9cGUUTGA==",
  tinyimage: "cnB5KlRGUhQTI-5rE20duQ==",
  tinyimagebusiness: "Mqw-SuwUbjsLyUl0cL7NwQ==",
  tinyimagefreelancer: "87Lz5x2EGS_V2JlT5Wdj4A==",
  tinyimageteam: "UbbebKfcyn1tbGmoFfWRsg==",
  updod: "iAlfHJ3atH9W0TAEFhVX6Q==",
  urfGN: "uf26HqASPHZpT4fzQKW4Tw==",
  vwuyc: "IV6hmfqrh1tbQfn2kZjU5w==",
  wOXfj: "87Lz5x2EGS_V2JlT5Wdj4A==",
  wQmLM: "nnGHFuOd73r35gXPrNIcbg==",
  weblify: "wye5lxKiEzKmcwXE66_jcA==",
  wimcX: "FUo7kr7eDs6AlEF8mDtGXA==",
  wpohs: "LU7wE9IqOQgA23R-HJCwcg==",
  zWeJn: "r0PpVS0vC9ZTHDKglgKCDQ==",
  znros: "SyF56ckoIJx8EGtgCgZl0g=="
};
